





































































































































import { DocumentNonReconnuApi } from "../api/DocumentNonReconnuApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import DocumentNonReconnuListFilters from "./DocumentNonReconnuListPartials/DocumentNonReconnuListFilters.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import DocumentNonReconnuReclasserModal from "./DocumentNonReconnuReclasserModal.vue";
import { DocumentNonReconnu } from "../models/DocumentNonReconnu";

export default {
    name: "DocumentNonReconnuList",
    components: {
        Pagination,
        PerPage,
        DocumentNonReconnuListFilters,
        AutoRefresh,
        DocumentNonReconnuReclasserModal,
    },
    data() {
        return {
            documents: [],
            DocumentNonReconnuApi: new DocumentNonReconnuApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            reclasserModal: {
                document: null,
                show: false,
            },
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "files",
                sort: this.sort,
            };

            params = _.assign(params, self.filters);
            self.loading = !hideLoading;

            return self.DocumentNonReconnuApi.getAll(params)
                .then(function (response) {
                    let { data, paginator } = response;

                    self.documents = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;

                    return self.documents;
                })
                .catch(function (error) {
                    self.documents = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        getDocuments() {
            return this.loadPage(this.currentPage);
        },
        refreshDocuments() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.loadPage(1);
        },
        updateSort(sort): void {
            this.sort = sort;
            this.loadPage(1);
        },
        // Actions
        reclasserDocument(document) {
            this.reclasserModal.document = document;
            this.reclasserModal.show = true;
        },
        onReclasserModalClose() {
            this.reclasserModal.show = false;
            this.reclasserModal.document = null;
        },
        onReclassed(metadata) {
            let label =
                DocumentNonReconnu.TYPE_LABELS[metadata && metadata.type] ||
                "la catégorie choisie";
            let text =
                metadata && metadata.count > 1
                    ? metadata.count + " fiches ont été créées."
                    : "";

            this.getDocuments();
            swal("Le document a été reclassé en " + label, text, "success");
        },
        journaliserDocument(document) {
            let self = this;
            swal({
                title: "Envoyer ce document vers le journal ?",
                text:
                    "Une entrée de journal sera créée avec le PDF attaché, " +
                    "et le document quittera cette liste.",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            }).then(function () {
                self.DocumentNonReconnuApi.journaliser(document.id).then(
                    function () {
                        self.getDocuments();
                        swal(
                            "Le document a été envoyé vers le journal !",
                            "",
                            "success"
                        );
                    }
                );
            });
        },
        deleteDocument(document) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer ce document&nbsp;?",
                "Le fichier ne sera plus accessible depuis cette liste."
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.DocumentNonReconnuApi.delete(document.id, raison)
                    .then(function () {
                        self.getDocuments();
                        swal(
                            "Le document a bien été supprimé !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
